import MusicRegistrationHeader from '@/components/Layout/MusicRegistrationHeader';
import { Link } from '@/i18n/navigation';
import { useOptionalI18n } from '@/i18n';
import { localizeText } from '@/i18n/options';

const MusicRegistrationRolePage = () => {
  const { locale } = useOptionalI18n();
  const l = (text: string) => localizeText(locale, text);

  return (
    <div className="theme-music min-h-screen font-redesign-body text-gray-900">
      <MusicRegistrationHeader />
      <main className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-4xl items-center px-4 py-10 sm:px-6 sm:py-16 lg:px-8">
        <section className="w-full text-center" aria-labelledby="music-registration-title">
          <h1 id="music-registration-title" className="text-3xl font-bold tracking-tight sm:text-4xl">
            {l('Who are you joining as?')}
          </h1>

          <div className="mx-auto mt-10 grid max-w-2xl gap-4 sm:grid-cols-2 sm:gap-6">
            <Link
              to="/music/register/tutor"
              className="group flex min-h-52 cursor-pointer flex-col items-start rounded-2xl border border-gray-200 bg-white p-6 text-left shadow-sm transition-colors duration-200 hover:border-primary-300 hover:bg-primary-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:ring-offset-2"
            >
              <span className="mt-5 text-xl font-semibold">{l("I'm a Music Tutor")}</span>
              <span className="mt-2 text-sm leading-6 text-neutral-600">{l('Create your profile and offer music lessons.')}</span>
              <span className="mt-auto pt-5 text-sm font-semibold text-primary group-hover:text-primary-600">{l('Register as a tutor →')}</span>
            </Link>

            <Link
              to="/music/register/parent"
              className="group flex min-h-52 cursor-pointer flex-col items-start rounded-2xl border border-gray-200 bg-white p-6 text-left shadow-sm transition-colors duration-200 hover:border-primary-300 hover:bg-primary-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:ring-offset-2"
            >
              <span className="mt-5 text-xl font-semibold">{l("I'm a Parent or Student")}</span>
              <span className="mt-2 text-sm leading-6 text-neutral-600">{l('Tell us what music lessons you are looking for.')}</span>
              <span className="mt-auto pt-5 text-sm font-semibold text-primary group-hover:text-primary-600">{l('Register as a parent or student →')}</span>
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
};

export default MusicRegistrationRolePage;
